 
import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin/admin.service';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss']
})
export class AdminUsersComponent implements OnInit {

  // =========================================================
  // Admin Users
  // =========================================================

  rows: any[] = [];

  showDialog: boolean = false;

  editor: any = {};

  editorFields: any[] = [
    { name: 'userId', label: 'ID' },
    { name: 'fullName', label: 'Name' },
    { name: 'email', label: 'Email' },
    { name: 'isActive', label: 'Active' }
  ];


  // =========================================================
  // Pagination
  // =========================================================

  currentPage: number = 1;

  pageSize: number = 10;


  // =========================================================
  // Constructor
  // =========================================================

  constructor(
    private adminService: AdminService
  ) { }


  // =========================================================
  // Init
  // =========================================================

  ngOnInit(): void {

    this.loadPageData();

  }


  // =========================================================
  // Load Admin Users
  // =========================================================

  loadPageData(): void {

    this.adminService
      .getAdmins()
      .subscribe({

        next: (response: any) => {

          this.rows = Array.isArray(response)
            ? response
            : [];

          this.validateCurrentPage();

        },

        error: (error: any) => {

          console.error(
            'Error loading admin users:',
            error
          );

          this.rows = [];

          this.currentPage = 1;

        }

      });

  }


  // =========================================================
  // Add Admin User
  // =========================================================

  openNew(): void {

    this.editor = {};

    this.showDialog = true;

  }


  // =========================================================
  // Edit Admin User
  // =========================================================

  edit(row: any): void {

    this.editor = { ...row };

    this.showDialog = true;

  }


  // =========================================================
  // Save Admin User
  // =========================================================

  save(): void {

    this.adminService
      .saveAdmin(this.editor)
      .subscribe(() => {

        this.showDialog = false;

        this.loadPageData();

      });

  }


  // =========================================================
  // Pagination
  // =========================================================

  // Get paginated users
  get pagedUsers(): any[] {

    const startIndex =
      (this.currentPage - 1) * this.pageSize;

    return this.rows.slice(
      startIndex,
      startIndex + this.pageSize
    );

  }


  // Total pages
  get totalPages(): number {

    return Math.max(
      1,
      Math.ceil(
        this.rows.length / this.pageSize
      )
    );

  }


  // Generate page numbers
  get pageNumbers(): number[] {

    return Array.from(
      { length: this.totalPages },
      (_, index) => index + 1
    );

  }


  // First displayed record
  get startRecord(): number {

    if (this.rows.length === 0) {
      return 0;
    }

    return (
      (this.currentPage - 1) * this.pageSize
    ) + 1;

  }


  // Last displayed record
  get endRecord(): number {

    return Math.min(
      this.currentPage * this.pageSize,
      this.rows.length
    );

  }


  // Change page
  changePage(page: number): void {

    if (
      !Number.isInteger(page) ||
      page < 1 ||
      page > this.totalPages
    ) {
      return;
    }

    this.currentPage = page;

  }


  // Previous page
  previousPage(): void {

    this.changePage(
      this.currentPage - 1
    );

  }


  // Next page
  nextPage(): void {

    this.changePage(
      this.currentPage + 1
    );

  }


  // Change rows per page
  onPageSizeChange(): void {

    this.currentPage = 1;

  }


  // Validate current page after loading
  private validateCurrentPage(): void {

    this.currentPage = Math.max(
      1,
      Math.min(
        this.currentPage,
        this.totalPages
      )
    );

  }

}
